var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "navigation-bar"
  }, [_c('div', {
    staticClass: "navigation-bar-left"
  }), _c('div', {
    staticClass: "navigation-bar-title"
  }, [_vm._v($t("arh4n24", "加入企业"))]), _c('div', {
    staticClass: "navigation-bar-right"
  })]), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "form-content pt-[20px]"
  }, [_c('div', {
    staticClass: "flex gap-[20px] bg-[#D6FFF4] border-[#13C194] border-solid border-[1px] border-[2px] rounded-md p-[10px] items-center"
  }, [_c('img', {
    staticClass: "w-[24px] h-[24px]",
    attrs: {
      "src": require("@/assets/icon/success.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('div', {
    staticClass: "text-[16px] text-left font-500 text-[#147179]"
  }, [_vm._v(` ${$t("k0196ue", "申请加入成功，等待管理员审核")} `)]), _c('div', {
    staticClass: "text-left"
  })])])])])]);
}];
export { render, staticRenderFns };